import { TypedDocumentNode, gql } from '@apollo/client';

import { Card } from '@sorare/core/src/components/card/Card';
import { ANY_SPORT_PLAY } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { BuyCongratsScreen } from '../BuyCongratsScreen';
import { BuyCommonBenchObjectCongratsScreen_composeTeamBenchObjectInterface } from './__generated__/index.graphql';

type Props = {
  commonPlayer: BuyCommonBenchObjectCongratsScreen_composeTeamBenchObjectInterface & {
    __typename: 'ComposeTeamBenchCommonPlayer';
  };
  open: boolean;
  onClose: () => void;
};

export const BuyCommonBenchObjectCongratsScreen = ({
  commonPlayer,
  open,
  onClose,
}: Props) => {
  const { generateSportContextPath } = useSportContext();
  return (
    <BuyCongratsScreen
      main={<Card card={commonPlayer} />}
      fallbackIosRoute={generateSportContextPath(ANY_SPORT_PLAY)}
      playerDisplayName={commonPlayer.anyPlayer.displayName}
      open={open}
      onClose={onClose}
    />
  );
};

BuyCommonBenchObjectCongratsScreen.fragments = {
  composeTeamBenchObjectInterface: gql`
    fragment BuyCommonBenchObjectCongratsScreen_composeTeamBenchObjectInterface on ComposeTeamBenchObjectInterface {
      id
      anyPlayer {
        slug
        displayName
      }
      ...Card_composeTeamBenchObjectInterface
    }
  ` as TypedDocumentNode<BuyCommonBenchObjectCongratsScreen_composeTeamBenchObjectInterface>,
};
